import { Warning } from '@upright/ui/icons';
import {
  EmptyHeader,
  ModalDialog,
  ModalContent,
  ModalIconWrapper,
  ModalTitle,
  ModalDescription,
  ModalButton,
} from './shared-modal-components';
import styled from 'styled-components';

interface UpgradeErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string | null;
}

/**
 * Shown when the upgrade checkout fails to initialize (e.g. network error, missing org ID).
 * Follows the same pattern as the error states in the DMA Consultant company creation wizard.
 */
export function UpgradeErrorModal({ isOpen, onClose, errorMessage }: UpgradeErrorModalProps) {
  if (!isOpen) return null;

  return (
    <ModalDialog title="Payment error" onClose={onClose} width="medium" renderHeader={EmptyHeader}>
      <ModalContent>
        <ErrorIconWrapper>
          <Warning width={48} height={48} color="var(--color__red-600)" />
        </ErrorIconWrapper>
        <ModalTitle>Something went wrong</ModalTitle>
        <ModalDescription>
          {errorMessage || 'Failed to initialize payment. Please try again later or contact Upright support.'}
        </ModalDescription>
        <ModalButton onClick={onClose} variant="primary" block>
          Close
        </ModalButton>
      </ModalContent>
    </ModalDialog>
  );
}

const ErrorIconWrapper = styled(ModalIconWrapper)`
  background: var(--color__red-100);
`;
